import React, { useEffect, useState } from "react";
import Wrapper from "../components/Wrapper";
import Button from "../components/Button";
import Option from "../components/Option";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateScreenAction, addScreenAction } from "../actions";
import { WATER_TYPE, WATER_SOURCE, SHOW_MORE } from "../constants";

function Question1({ dispatch, updateScreen, screens, addScreen }) {
  const [cleanWaterSelected, setCleanWaterSelected] = useState(false);
  const [dirtyWaterSelected, setDirtyWaterSelected] = useState(false);

  const options = [
    {
      name: "Clean Water",
      iconName: "clean-water",
      description:
        "This pump selector tool defines clean water as town water, mains water or rain water.",
      optionClassName: `${
        cleanWaterSelected ? "c-quiz_options--option-selected" : ""
      }`,
      action: () => {
        setCleanWaterSelected(true);
        setDirtyWaterSelected(false);
      },
    },

    {
      name: "Dirty Water",
      iconName: "dirty-water",
      description:
        "This pump selector tool defines dirty water as storm water, groundwater, or domestic wastewater (kitchen, laundry, bathroom or toilet).",
      optionClassName: `${
        dirtyWaterSelected ? "c-quiz_options--option-selected" : ""
      }`,
      action: () => {
        setCleanWaterSelected(false);
        setDirtyWaterSelected(true);
      },
    },
  ];

  useEffect(() => {
    if (screens.answers.WATER_TYPE) {
      if (screens.answers.WATER_TYPE === "clean_water") {
        setCleanWaterSelected(true);
      }
      if (screens.answers.WATER_TYPE === "dirty_water") {
        setDirtyWaterSelected(true);
      }
    }
  }, [screens.answers.WATER_TYPE]);

  const getValue = () => {
    if (cleanWaterSelected) {
      return "clean_water";
    } else {
      return "dirty_water";
    }
  };
  const isBtnDisabled = !cleanWaterSelected && !dirtyWaterSelected;
  return (
    <Wrapper stepNo={"1"} question={"1. What type of water will be pumped?"}>
      <div
        className="uk-child-width-expand@s uk-text-center uk-grid-match c-quiz_options"
        uk-grid="margin: uk-margin-small uk-margin@s"
      >
        {options.map((option) => {
          return (
            <Option
              key={`opt_${option.name}`}
              name={option.name}
              iconName={option.iconName}
              description={option.description}
              optionClassName={option.optionClassName}
              onClick={option.action}
            />
          );
        })}
      </div>

      <Button
        text={"continue"}
        secondary={false}
        disabled={isBtnDisabled}
        onClick={() => {
          const value = getValue();
          if (value === "clean_water") {
            updateScreen({
              curr_screen: WATER_TYPE,
              next_screen: WATER_SOURCE,
              answer: value,
            });
          } else {
            updateScreen({
              curr_screen: WATER_TYPE,
              next_screen: SHOW_MORE,
              answer: value,
            });
          }
        }}
      />
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question1);
